import {
    ReactFlow,
    type Node,
    type Edge,
    useNodesState,
    useEdgesState,
    ReactFlowProvider,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { LinkNode, LinkNodeData } from "./LinkNode";

const nodeTypes = {
    linkNode: LinkNode,
};

export type CalculationVeracityNode =
    | Node
    | (Node & LinkNodeData);

type CalculationVeracityDiagramProps = {
    nodes: CalculationVeracityNode[];
    edges: Edge[];
};

const CalculationVeracityDiagramComponent = ({
    nodes: initialNodes,
    edges: initialEdges,
}: CalculationVeracityDiagramProps) => {
    const [nodes, , onNodesChange] = useNodesState(initialNodes);
    const [edges, , onEdgesChange] = useEdgesState(initialEdges);

    return (
        <div className="h-[60vh] w-full px-3" >
            <ReactFlow
                nodes={nodes}
                edges={edges}
                nodesConnectable={false}
                nodesDraggable={false}
                edgesFocusable={false}
                edgesReconnectable={false}
                nodesFocusable={false}
                defaultViewport={{zoom: 0.2, x: 500, y: -100
                }}
                nodeTypes={nodeTypes}
                style={{ backgroundColor: "#F7F9FB" }}
                onError={(e) => console.log(e)}
                onNodesChange={nodes => onNodesChange(nodes)}
                onEdgesChange={edges => onEdgesChange(edges)}
                zoomOnDoubleClick={false}
                
                maxZoom={1}
                minZoom={0.01}
            >
            </ReactFlow>
        </div>
    );
};

export const CalculationVeracityDiagram = (
    props: CalculationVeracityDiagramProps
) => {
    return (
        <ReactFlowProvider>
            <CalculationVeracityDiagramComponent {...props} />
        </ReactFlowProvider>
    );
};
